import React from 'react'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

import * as ComprasCrud from 'services/compra.service'

import MainCard from './mainCard'

const portletBreadcrumbs = [
  { name: 'Compras', path: `/${CodigosTransaccionesConstant.COMPRAS_LISTA}` },
  { name: 'Estado de Cuenta' }
]

const EstadoCuentaPage = ({ match }) => {
  const [estadoCuentaInfo, setEstadoCuentaInfo] = React.useState(null)

  React.useEffect(() => {
    ComprasCrud.getCompraEstadoCuenta(match.params.idCompra).then(({ data }) => {
      setEstadoCuentaInfo(data)
    })
  }, [match.params.idCompra])

  return (
    <>
      {estadoCuentaInfo && (
        <MainCard estadoCuentaInfo={estadoCuentaInfo} portletBreadcrumbs={portletBreadcrumbs} />
      )}
    </>
  )
}

export default EstadoCuentaPage
